import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Maximize2, X } from "lucide-react";
import { SERIF } from "../soulumoPractice/practiceApi";
import { TogetherRhythm } from "./TogetherRhythm";

// A scannable invitation for a room: small on the card, full-screen for the workshop screen.
export const TogetherQr = ({ link, title, invite }) => {
  const [src, setSrc] = useState("");
  const [big, setBig] = useState(false);
  useEffect(() => { QRCode.toDataURL(link, { width: 720, margin: 1, color: { dark: "#0b1a33", light: "#f5ecd9" } }).then(setSrc).catch(() => {}); }, [link]);
  if (!src) return null;
  return (
    <>
      <div className="mt-5 flex items-center gap-4 rounded-2xl border border-[#d7bb7a]/25 p-4" data-testid="together-qr">
        <img src={src} alt="QR code to join" className="h-28 w-28 rounded-lg" />
        <div>
          <p className="text-sm text-[#e9e2d0]">People in the room can scan this with their phone camera.</p>
          <button type="button" onClick={() => setBig(true)} data-testid="together-qr-fullscreen"
            className="mt-3 inline-flex items-center gap-2 rounded-full border border-[#d7bb7a]/50 px-4 py-2 text-xs uppercase tracking-[0.2em] text-[#d7bb7a] transition-colors hover:bg-[#d7bb7a]/10">
            <Maximize2 size={13} /> Show on screen
          </button>
        </div>
      </div>
      {big && (
        <div className="fixed inset-0 z-[300] flex flex-col items-center justify-center bg-[#0b1a33] px-6 text-center" data-testid="together-qr-screen">
          <button type="button" onClick={() => setBig(false)} aria-label="Close" data-testid="together-qr-close" className="absolute right-5 top-5 rounded-full p-2 text-[#b9ad8f] hover:bg-white/10"><X size={22} /></button>
          <p className="text-[0.7rem] uppercase tracking-[0.4em] text-[#d7bb7a]">21 Days Together</p>
          <h2 className="mt-3 max-w-3xl text-4xl sm:text-6xl font-light text-[#f3ecd9]" style={{ fontFamily: SERIF }}>{title}</h2>
          <img src={src} alt="QR code to join" className="mt-8 w-[min(70vw,60vh)] rounded-2xl" />
          <p className="mt-6 text-xl italic text-[#e9e2d0]" style={{ fontFamily: SERIF }}>Scan to join. For the next 21 days, let's continue this together.</p>
          <div className="mt-4 w-full max-w-md"><TogetherRhythm intensity={invite.intensity} night={invite.night} day={invite.day} /></div>
        </div>
      )}
    </>
  );
};
